"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_base64Binary = exports.RTTI_base64BinaryType = void 0;
var io_ts_1 = require("io-ts");
var RTTI_base64BinaryType = (function (_super) {
    __extends(RTTI_base64BinaryType, _super);
    function RTTI_base64BinaryType() {
        var _this = _super.call(this, 'RTTI_base64BinaryType', function (m) { return typeof m === 'string'; }, function (m, c) { return (_this.is(m) ? (0, io_ts_1.success)(m) : (0, io_ts_1.failure)(m, c)); }, io_ts_1.identity) || this;
        return _this;
    }
    return RTTI_base64BinaryType;
}(io_ts_1.Type));
exports.RTTI_base64BinaryType = RTTI_base64BinaryType;
exports.RTTI_base64Binary = new RTTI_base64BinaryType();
//# sourceMappingURL=RTTI_base64Binary.js.map